import PropTypes from 'prop-types';

const CheckboxField = ({ input, disabled, label, labelRequired, meta: { touched, error, warning, submitError }, helpText, cssClass }) => {
  const { name, value, onChange, onBlur, onFocus } = input;

  if (!error) {
    error = submitError;
  }

  return (
    <div className={`form-group checkbox${cssClass ? ' ' + cssClass : ''}${touched && error ? ' error' : ''}`}>
      <input
        type="checkbox"
        id={name}
        className="form-control"
        name={name}
        checked={value}
        disabled={disabled}
        onChange={onChange}
        onBlur={onBlur}
        onFocus={onFocus}
      />
      {label && (
        <label htmlFor={name}>
          {label}
          {labelRequired && <abbr title="Required">*</abbr>}
        </label>
      )}
      {helpText && <div className="text-info">{helpText}</div>}
      {touched && error && <div className="text-danger">{error}</div>}
      {touched && warning && !error && <div className="text-warning">{warning}</div>}
    </div>
  );
};

CheckboxField.propTypes = {
  input: PropTypes.object.isRequired,
  label: PropTypes.string,
  labelRequired: PropTypes.bool,
  meta: PropTypes.object,
  helpText: PropTypes.string,
  cssClass: PropTypes.string,
  disabled: PropTypes.bool,
};

export default CheckboxField;
